import { makeAutoObservable } from "mobx";
import { ZEntityErrorType } from "src/business/error/ZEntityError";
import { MfErrorsListStore } from "src/components/MForm/components/MfErrorsListView";
import { findDataNode } from "src/components/MForm/formNav/findDataNode";
import { MFormStore } from "src/components/MForm/MFormStore";

import { mFormDemoMeta } from "./mFormDemoMeta";

export const mFormDemoStore = makeAutoObservable({
  errListStore: new MfErrorsListStore(new MFormStore()),
  get form(): MFormStore {
    return this.errListStore.form;
  },
  init() {
    this.form.setMeta(mFormDemoMeta);
    this.form.setExternalErrors([
      {
        type: ZEntityErrorType.tech,
        attributePath: "ms.mass",
        message: "Первое сообщение",
      },
      {
        type: ZEntityErrorType.tech,
        attributePath: "ms.mass",
        message: "Второе сообщение",
      },
    ]);
  },
  get firstNode() {
    return findDataNode(this.form.root, ["ms", "first"]);
  },
  get allDisabled() {
    return this.form.root.disabled;
  },
  setAllDisabled(value: boolean) {
    this.form.root.setDisabled(value);
  },
});
